import React from 'react'
import PropTypes from 'prop-types'

import { Image } from '../Image/Image'
import { Audio } from '../Audio/Audio'
import { SettingsButton } from '../SettingsButton/SettingsButton'
import { NextButton } from '../NextButton/NextButton'
import oldKazanImg from '../../resources/oldKzn.jpg'

import styles from './GameWrapper.module.scss'
import barsikImg from './barsik.png'
import hatirImg from './hatir.png'
import bgAudio from './bg-music-loop.mp3'


function GameWrapper({ people, win, children }) {
    return (
        <>
            <Image src={oldKazanImg} className={styles.bg} />
            <div className={styles.body}>
                {children}
            </div>
            <Audio src={bgAudio} autoplay loop />
            <SettingsButton />

            {
                people === '1'
                    ? (
                        <>
                            <Image src={barsikImg} className={styles.barsik1} />
                            <Image src={hatirImg} className={styles.hatir} />
                        </>
                    )
                    : null
            }

            {
                people === '2'
                    ? (
                        <div>2</div>
                    )
                    : null
            }

            {
                win
                    ? <NextButton />
                    : null
            }
        </>
    )
}

GameWrapper.propTypes = {
    people: PropTypes.oneOf(['0', '1', '2']),
    win: PropTypes.bool,
    children: PropTypes.any,
}

export { GameWrapper }
